import React from "react";
import NeoBadge from "../../../../components/Common/NeoBadge";
import { HEALTH_LEVELS } from "../constants";

const PlatformClientHealthBadge = ({ score, level, compact = false }) => {
    const config = HEALTH_LEVELS[level] || HEALTH_LEVELS.red;

    if (compact) {
        return (
            <NeoBadge color={config.color}>
                <i className={`mdi ${config.icon} me-1`} />
                {score ?? "—"}
            </NeoBadge>
        );
    }

    return (
        <div className="d-flex align-items-center gap-2">
            <div
                style={{
                    width: 36,
                    height: 36,
                    borderRadius: "50%",
                    background: level === "green" ? "#e8f5e9" : level === "yellow" ? "#fff8e1" : "#ffebee",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                }}
            >
                <span style={{
                    fontWeight: 800,
                    fontSize: 11,
                    color: level === "green" ? "#2e7d32" : level === "yellow" ? "#f57f17" : "#c62828",
                }}>
                    {score ?? "—"}
                </span>
            </div>
            <div>
                <div className="fw-bold font-size-12 text-dark">{config.label}</div>
                <div className="text-muted font-size-10">Health Score</div>
            </div>
        </div>
    );
};

export default PlatformClientHealthBadge;
